import {
  chkCertNumProps,
  joinProps,
  loginProps,
  memInfProps,
  pwdResetProps,
} from "interface/user";
import api from "./api";

//로그인
export const loginApi = async (params: loginProps) => {
  const res = await api({
    method: "post",
    url: "login/lgnProc",
    data: params,
  });

  return res;
};

//로그아웃
export const logoutApi = async () => {
  const res = await api({
    method: "get",
    url: "login/logout",
  });

  return res;
};

//로그인 상태 체크
export const logChkApi = async () => {
  const res = await api({
    method: "get",
    url: `login/lgnChk`,
  });

  return res;
};

//비밃번호 찾기 메일 확인
export const checkEmlIdApi = async ({ emlId }: { emlId: string }) => {
  const res = await api({
    method: "post",
    url: `login/reqLgnPwdReset`,
    data: { emlId },
  });

  return res;
};

//비밀번호 재설정 url
export const pwdCheckResetUrlApi = async ({ param }: { param: string }) => {
  const res = await api({
    method: "get",
    url: `login/chkLgnPwdResetUrl${param}`,
  });

  return res;
};

//비밀번호 재설정
export const pwdRestApi = async (params: pwdResetProps) => {
  const { param, ...data } = params;
  const res = await api({
    method: "post",
    url: `login/chkLgnPwdResetUrl?${param}`,
    data,
  });

  return res;
};

//회원가입메일주소 체크
export const chckMailApi = async ({ emlId }: { emlId: string }) => {
  const res = await api({
    method: "post",
    url: `join/chkMailId`,
    data: { emlId },
  });

  return res;
};

//회원가입인증번호체크
export const chkCertNumApi = async (params: chkCertNumProps) => {
  const res = await api({
    method: "post",
    url: `join/chkCertNum`,
    data: params,
  });

  return res;
};

//회원가입
export const confirmApi = async (params: joinProps) => {
  const res = await api({
    method: "post",
    url: `join/confirm`,
    data: params,
  });

  return res;
};

//회원정보 조회
export const memInfoApi = async () => {
  const res = await api({
    method: "get",
    url: `member/memInfo`,
  });

  return res;
};

//회원정보 변경
export const memInfUpdateApi = async (params: Partial<memInfProps>) => {
  const res = await api({
    method: "post",
    url: `member/memInfoModify`,
    data: params,
  });

  return res;
};

//비밀번호체크
export const lgnPwdChkApi = async (params: loginProps) => {
  const res = await api({
    method: "post",
    url: `member/lgnPwdChk`,
    data: params,
  });

  return res;
};

//비밀번호 재설정
export const lgnPwdResetApi = async (params: any) => {
  const res = await api({
    method: "post",
    url: `member/lgnPwdReset`,
    data: params,
  });

  return res;
};

//회원탈퇴
export const deleteAccountApi = async () => {
  const res = await api({
    method: "get",
    url: `member/memSo`,
  });

  return res;
};
